import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  runNightAudit,
  fetchNightAuditHistory,
  fetchNightAuditDetail,
  type RunNightAuditPayload,
  type NightAuditHistoryQuery,
} from '@/services/api/night-audit.api';

export function useNightAuditHistory(query: NightAuditHistoryQuery) {
  return useQuery({
    queryKey: ['night-audit', 'history', query],
    queryFn: () => fetchNightAuditHistory(query),
    staleTime: 30_000,
  });
}

export function useNightAuditDetail(id: string | null) {
  return useQuery({
    queryKey: ['night-audit', id],
    queryFn: () => fetchNightAuditDetail(id as string),
    staleTime: 30_000,
    enabled: id !== null,
  });
}

export function useRunNightAudit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: RunNightAuditPayload) => runNightAudit(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['night-audit'] });
    },
  });
}
